<script>
import form from '@/mixins/form'
import * as acessofuncionalidade from '@/api/acessofuncionalidade'

export default {
  mixins: [form],
  props: {
    mode: { type: String, default: 'tab' }
  },
  async mounted () {
    const info = await this.backend.info()
    this.fields = info.form.fields
  },
  data: () => ({
    backend: acessofuncionalidade,
    fields: [],
    form: {}
  })
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Adicionar" @onClose="() => $emit('cancel')">
    <dx-form ref="form" label-location="top" :form-data="form" :items="fields" :onEditorEnterKey="salvar">
      <app-acessotela-select slot="fieldTela" slot-scope="data" :model="form.tela" @change="v => form.tela = v" />
    </dx-form>
    <ui-acao-form @save="salvar" @cancel="$emit('cancel')" />
  </ui-layout-modal>
</template>

<style scoped>
  .card-form {
    text-align: left;
  }
</style>
